module.exports = __webpack_public_path__ + "media/images/pic/teachers/monika-zachaj-51283f1b7e69212a6d1e7d4917cf2ac9.webp";